/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ProfileContactResponseEmailType = typeof ProfileContactResponseEmailType[keyof typeof ProfileContactResponseEmailType] | null;


export const ProfileContactResponseEmailType = {
  personal: 'personal',
  professional: 'professional',
} as const;
